// @Version: 1.0.0
export enum FC_IMG_TEXT {
    IMGTEXT = "imgtext"
}

export enum IMGPOS {
    LEFT = 0,
    RIGHT
}

export enum IMGSIZE {
    COLUMN = 0,
    SEVENTYCOLUMN,
    ROW
}

export interface ILinkImgText {
    src?: string,
    filename?: string
}

export interface IImageImgText {
    altText: string,
    imgText?: string
}